import { render, staticRenderFns } from "./manage-booking-share-button.vue?vue&type=template&id=503c54d4"
import script from "./manage-booking-share-button.vue?vue&type=script&lang=ts"
export * from "./manage-booking-share-button.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-share-button.vue?vue&type=style&index=0&id=503c54d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports